import { SPONSOR_TIER } from '@/domain/center.js'
import { LOCATION_TYPE } from '@/domain/location/constants'
import { LOCAL_SPONSOR_BOOST } from './constants'
import { isNonEmptyString } from '@/utils/checks'
export const boostLocalSponsorForCityLocations = (
  sponsorTier: number,
  locationType: string
): number => {
  if (!isNonEmptyString(locationType)) {
    return 0
  }
  if (
    sponsorTier === SPONSOR_TIER.LOCAL &&
    locationType === LOCATION_TYPE.CITY
  ) {
    return LOCAL_SPONSOR_BOOST
  }
  return 0
}
